export default "__VITE_ASSET__DZxxn61l__"